export default "__VITE_ASSET__19e666ac__"